import { useMutation, useQuery } from "@tanstack/react-query";

import {
  addMaterial,
  deleteMaterial,
  getMaterial,
  getMaterials,
  updateMaterial,
} from "@/api";
import type { Material } from "@/types";

export const materialsQueryKeys = {
  useMaterial: (materialId?: Material["id"]) => [
    "materials",
    "getMaterial",
    materialId,
  ],
  useMaterials: () => ["materials", "getMaterials"],
  useAllMaterials: () => ["materials", "all"],
};

export const useMaterials = () => {
  const useMaterial = (materialId?: Material["id"]) =>
    useQuery({
      queryFn: () => getMaterial(materialId),
      queryKey: materialsQueryKeys.useMaterial(materialId),
      enabled: !!materialId,
    });

  const useAllMaterials = () =>
    useQuery({
      queryFn: getMaterials,
      queryKey: materialsQueryKeys.useAllMaterials(),
    });

  const useAddMaterial = () => useMutation({ mutationFn: addMaterial });
  const useUpdateMaterial = () => useMutation({ mutationFn: updateMaterial });
  const useDeleteMaterial = () => useMutation({ mutationFn: deleteMaterial });

  return {
    useMaterial,
    useAllMaterials,
    useAddMaterial,
    useUpdateMaterial,
    useDeleteMaterial,
  };
};
